var map = {
	"./404.svg": "0VJI",
	"./atom-01.svg": "nvAz",
	"./award-03.svg": "8ret",
	"./bank-note-03.svg": "6Im0",
	"./bar-chart-04.svg": "EvWF",
	"./bar-chart-05.svg": "qE2/",
	"./bar-chart-07.svg": "+faO",
	"./bar-chart-08.svg": "TEly",
	"./bar-chart-10.svg": "4eRG",
	"./bar-chart-12.svg": "/uJ6",
	"./bar-chart-circle-01.svg": "l/e4",
	"./bar-chart-circle-02.svg": "oigw",
	"./bar-chart-square-01.svg": "MrTy",
	"./bar-chart-square-02.svg": "aFBn",
	"./bar-line-chart.svg": "e8kV",
	"./beaker-02.svg": "lU+n",
	"./bezier-curve-03.svg": "lEj/",
	"./book-open-01.svg": "5c5K",
	"./briefcase-01.svg": "Gufp",
	"./browser.svg": "o3Fb",
	"./bug.svg": "dm9c",
	"./build.svg": "CcSC",
	"./building-03.svg": "dBwk",
	"./building-05.svg": "zHAo",
	"./building-07.svg": "W6Wr",
	"./building-08.svg": "C16L",
	"./button.svg": "awTP",
	"./calendar.svg": "zTvN",
	"./cascader.svg": "Vo4H",
	"./certificate-01.svg": "5Dc2",
	"./chart.svg": "qHis",
	"./check-heart.svg": "cs7F",
	"./check-verified-01.svg": "IJNR",
	"./check.svg": "nnyk",
	"./checkbox.svg": "9b7A",
	"./clipboard.svg": "I03m",
	"./clock.svg": "8p7B",
	"./code.svg": "j8Uj",
	"./color.svg": "GUy9",
	"./component.svg": "jpfn",
	"./dashboard.svg": "Iuzh",
	"./date-range.svg": "kk7A",
	"./date.svg": "1xBr",
	"./dict.svg": "kknj",
	"./documentation.svg": "mL6r",
	"./download.svg": "kLc4",
	"./drag.svg": "6wtt",
	"./druid.svg": "PAJo",
	"./edit.svg": "04SK",
	"./education.svg": "G6Z1",
	"./email.svg": "Jvlx",
	"./empty.svg": "Icya",
	"./example.svg": "MVC2",
	"./excel.svg": "lXC7",
	"./exit-fullscreen.svg": "fXXK",
	"./eye-open.svg": "t7iP",
	"./eye.svg": "oxfE",
	"./form.svg": "HbpF",
	"./fullscreen.svg": "RvyL",
	"./github.svg": "WQRl",
	"./guide.svg": "HLEY",
	"./icon.svg": "Fbfg",
	"./input.svg": "y60P",
	"./international.svg": "353E",
	"./job.svg": "IorB",
	"./language.svg": "uSl1",
	"./link.svg": "kKPj",
	"./list.svg": "95W7",
	"./lock.svg": "EN3V",
	"./log.svg": "RnOJ",
	"./logininfor.svg": "M/g6",
	"./message.svg": "yvAI",
	"./money.svg": "IF5j",
	"./monitor.svg": "rDY3",
	"./nested.svg": "dbH1",
	"./number.svg": "PiO6",
	"./online.svg": "rvma",
	"./password.svg": "74Gh",
	"./pdf.svg": "9w3w",
	"./people.svg": "JP5W",
	"./peoples.svg": "JcqQ",
	"./phone.svg": "bDN7",
	"./post.svg": "kF6w",
	"./qq.svg": "igmI",
	"./question.svg": "wtlM",
	"./radio.svg": "EQj+",
	"./rate.svg": "keVZ",
	"./redis-list.svg": "ivtl",
	"./redis.svg": "oFVk",
	"./row.svg": "mpXY",
	"./search.svg": "EqOI",
	"./select.svg": "cMwg",
	"./server.svg": "XCKv",
	"./shopping.svg": "R6+o",
	"./size.svg": "1o6k",
	"./skill.svg": "sAjw",
	"./slider.svg": "S86h",
	"./star.svg": "rmOC",
	"./swagger.svg": "s8d+",
	"./switch.svg": "wOgh",
	"./system.svg": "fkAr",
	"./tab.svg": "R9fo",
	"./table.svg": "Ai84",
	"./textarea.svg": "0Xlb",
	"./theme.svg": "DYO4",
	"./time-range.svg": "Bj67",
	"./time.svg": "P2ym",
	"./tool.svg": "3T7B",
	"./tree-table.svg": "UAnU",
	"./tree.svg": "MWzf",
	"./upload.svg": "NI+5",
	"./user.svg": "EOg8",
	"./validCode.svg": "TcDJ",
	"./wechat.svg": "R0XQ",
	"./zip.svg": "HTd0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 80